<template>
  <Transition>
    <div v-if="show" class="dialog">
      <div class="dialog__header">
        <h3 class="text-black flex-1">{{ title }}</h3>
        <base-button color="white" @click.native="close">
          <svg
            class="fill-current text-grey-dark"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <path
              d="M19.78 18.36l-1.42 1.42L12 13.42l-6.36 6.36-1.42-1.42L10.58 12 4.22 5.64l1.42-1.42L12 10.58l6.36-6.36 1.42 1.42L13.42 12l6.36 6.36z"
            />
          </svg>
        </base-button>
      </div>
      <div class="dialog__content">
        <slot></slot>
      </div>
    </div>
  </Transition>
</template>

<script>
export default {
  name: 'DialogWindow',
  props: {
    title: {
      type: String,
      required: false,
      default: 'Shirtinator'
    }
  },
  data: () => ({
    show: false
  }),
  methods: {
    close() {
      this.show = false;
      this.$emit('close');
    },
    open() {
      this.show = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.dialog {
  @apply flex flex-col bg-white rounded-lg shadow-lg fixed overflow-hidden p-2 z-3000;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-width: 500px;
  max-height: 90%;
}
@screen xs {
  .dialog {
    min-width: 90%;
  }
}
.dialog__header {
  @apply flex p-2 justify-end items-center;
}

.dialog__content {
  @apply p-4;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s;
}
.v-enter,
.v-leave-to {
  opacity: 0;
}
</style>
